import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getPageContent } from 'context/actions/pages';
import PageHero from 'components/PageHero';
import dynamic from 'next/dynamic';
const TextEditorViewer = dynamic(() => import('components/TextEditorViewer'), { ssr: false });

// status: 'success' эсвэл result.code === 200 байж болох тул хоёуланд уян хатан байна
const isOk = (res) => res?.status === 'success' || res?.code === 200;

const Content = ({ pageId }) => {
    const router = useRouter();
    const { t } = useTranslation();
    const lang = useSelector((s) => s.system.lang);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    const id = pageId || router.query.id;

    useEffect(() => {
        if (!id) return;
        let cancelled = false;

        (async () => {
            setLoading(true);
            const res = await getPageContent(id);
            if (!cancelled) {
                if (isOk(res)) {
                    setData(res.data);
                }
                setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [id]);

    // Хэлээс хамаарч нэр/контент сонгох (монгол default, солонгос хоосон бол монгол fallback)
    const title = data ? (lang === 'ko' && data.nameKr ? data.nameKr : lang === 'en' && data.nameEn ? data.nameEn : data.name) : '';
    const html = data ? (lang === 'ko' && data.contentKr ? data.contentKr : lang === 'en' && data.contentEn ? data.contentEn : data.content) : '';
    const htmlRight = data
        ? lang === 'ko' && data.contentRightKr
            ? data.contentRightKr
            : lang === 'en' && data.contentRightEn
                ? data.contentRightEn
                : data.contentRight
        : '';
    const isTwoColumn = !!data?.isTwoColumn;

    if (loading) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center text-gray-500">
                Уншиж байна...
            </div>
        );
    }

    if (!data) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center">
                <div className="text-center">
                    <div className="text-5xl font-black text-brand-navy mb-2">404</div>
                    <p className="text-gray-600">Хуудас олдсонгүй</p>
                </div>
            </div>
        );
    }

    return (
        <>
            {!!data.coverImage && (
                <PageHero
                    title={title}
                    image={data.coverImage === 'default' ? '/homeCover.jpg' : data.coverImage}
                />
            )}
            {!data.coverImage && title && (
                <div className="max-w-4xl mx-auto px-6 pt-32 lg:pt-36 pb-4">
                    <h1 className="text-3xl md:text-4xl font-black text-brand-navy tracking-tight">
                        {title.toUpperCase()}
                    </h1>
                    <div className="mt-3 h-1 w-16 bg-brand-yellow" />
                </div>
            )}
            <div
                className={`${isTwoColumn ? 'max-w-7xl' : 'max-w-4xl'} mx-auto px-6 ${data.coverImage ? 'py-16' : 'pb-16'}`}
            >
                {isTwoColumn ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
                        <div>{html ? <TextEditorViewer data={html} /> : null}</div>
                        <div>{htmlRight ? <TextEditorViewer data={htmlRight} /> : null}</div>
                    </div>
                ) : html ? (
                    <TextEditorViewer data={html} />
                ) : (
                    <p className="text-lg text-gray-600">{t('content.empty')}</p>
                )}
            </div>
        </>
    );
};

export default Content;